import { render, staticRenderFns } from "./SeriesSummary.vue?vue&type=template&id=9284a91e&"
import script from "./SeriesSummary.vue?vue&type=script&lang=js&"
export * from "./SeriesSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports